"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.siteFlowConfigurationHalToJson = exports.apiPushConfigurationHalToJson = exports.apiPollConfigurationHalToJson = exports.promoStandardsConfigurationHalToJson = exports.ftpConfigurationHalToJson = exports.emailConfigurationHalToJson = exports.transmissionConfigurationTypeHalToJson = exports.transmissionConfigurationHalToPutRequestObject = exports.transmissionConfigurationHalToPostRequestObject = void 0;
const __1 = require("..");
const transmissionConfigurationHalToPostRequestObject = (tc, configurationType, credentialUrl) => {
    return {
        name: tc.name,
        transmissionMethodKey: configurationType,
        credentialsUrl: credentialUrl,
        [configurationType]: (0, exports.transmissionConfigurationTypeHalToJson)(tc, configurationType),
        accountUrl: tc._links.account.href
    };
};
exports.transmissionConfigurationHalToPostRequestObject = transmissionConfigurationHalToPostRequestObject;
const transmissionConfigurationHalToPutRequestObject = (tc, configurationType, credentialUrl) => {
    return {
        name: tc.name,
        transmissionMethodKey: configurationType,
        credentialsUrl: credentialUrl,
        [configurationType]: (0, exports.transmissionConfigurationTypeHalToJson)(tc, configurationType),
        accountUrl: tc._links.account.href,
        isArchived: tc.isArchived || false,
        version: tc.version,
    };
};
exports.transmissionConfigurationHalToPutRequestObject = transmissionConfigurationHalToPutRequestObject;
const transmissionConfigurationTypeHalToJson = (tc, configurationType) => {
    switch (configurationType) {
        case __1.TransmissionMethodKeysEnum.Email:
            return (0, exports.emailConfigurationHalToJson)(tc._embedded[configurationType]);
        case __1.TransmissionMethodKeysEnum.FileTransfer:
            return (0, exports.ftpConfigurationHalToJson)(tc._embedded[configurationType]);
        case __1.TransmissionMethodKeysEnum.PromoStandards:
            return (0, exports.promoStandardsConfigurationHalToJson)(tc._embedded[configurationType]);
        case __1.TransmissionMethodKeysEnum.ApiPoll:
            return (0, exports.apiPollConfigurationHalToJson)(tc._embedded[configurationType]);
        case __1.TransmissionMethodKeysEnum.ApiPush:
            return (0, exports.apiPushConfigurationHalToJson)(tc._embedded[configurationType]);
        case __1.TransmissionMethodKeysEnum.SiteFlow:
            return (0, exports.siteFlowConfigurationHalToJson)(tc._embedded[configurationType]);
        default:
            return {};
    }
};
exports.transmissionConfigurationTypeHalToJson = transmissionConfigurationTypeHalToJson;
const emailConfigurationHalToJson = (configuration) => {
    return {
        addresses: configuration.addresses,
        dynamicAddresses: configuration.dynamicAddresses,
        reminderTimeout: configuration.reminderTimeout,
        emails: configuration._embedded.emails.map(e => {
            return {
                actionTypeKey: e._links.actionType.name || '',
                templateUrl: e._links.template.href,
            };
        }),
    };
};
exports.emailConfigurationHalToJson = emailConfigurationHalToJson;
const ftpConfigurationHalToJson = (configuration) => {
    var _a;
    return {
        mode: configuration.mode,
        endpointUrl: configuration.endpointUrl,
        filesToCreate: configuration._embedded.filesToCreate.map(f => {
            return {
                path: f.path,
                actionTypeKey: f._links.actionType.name || '',
                templateUrl: f._links.template.href
            };
        }),
        pathsToWatch: (_a = configuration._embedded.pathsToWatch) === null || _a === void 0 ? void 0 : _a.map(p => {
            var _a;
            return {
                path: p.path,
                actionTypeKey: p._links.actionType.name || '',
                templateUrl: (_a = p._links.template) === null || _a === void 0 ? void 0 : _a.href
            };
        })
    };
};
exports.ftpConfigurationHalToJson = ftpConfigurationHalToJson;
const promoStandardsConfigurationHalToJson = (configuration) => {
    return {
        accountId: configuration.accountId || '',
        accountName: configuration.accountName || '',
        companyCode: configuration.companyCode,
        handleResponsesOnly: configuration.handleResponsesOnly,
        carrierServicesMapping: configuration.carrierServicesMapping,
        thirdPartyAccounts: configuration.thirdPartyAccounts,
        payloads: configuration._embedded.payloads.map(p => {
            return {
                actionTypeKey: p._links.actionType.name || '',
                templateUrl: p._links.template.href
            };
        })
    };
};
exports.promoStandardsConfigurationHalToJson = promoStandardsConfigurationHalToJson;
const apiPollConfigurationHalToJson = (configuration) => {
    return {
        mode: configuration.mode,
        clientId: configuration.clientId,
        payloads: configuration._embedded.payloads.map(p => {
            return {
                actionTypeKey: p._links.actionType.name || '',
                templateUrl: p._links.template.href
            };
        })
    };
};
exports.apiPollConfigurationHalToJson = apiPollConfigurationHalToJson;
const apiPushConfigurationHalToJson = (configuration) => {
    let statusCheck;
    if (configuration._embedded.statusCheck) {
        statusCheck = {
            responseTransformation: {
                templateUrl: configuration._embedded.statusCheck._embedded.responseTransformation._links.template.href
            },
            requests: configuration._embedded.statusCheck._embedded.requests.map(req => {
                var _a;
                return {
                    key: req.key,
                    path: req.path,
                    method: req.method,
                    templateUrl: (_a = req._links) === null || _a === void 0 ? void 0 : _a.template.href
                };
            })
        };
    }
    return {
        mode: configuration.mode,
        endpointUrl: configuration.endpointUrl,
        carrierServicesMapping: configuration.carrierServicesMapping,
        payloads: configuration._embedded.payloads.map(p => {
            return {
                path: p.path,
                actionTypeKey: p._links.actionType.name || '',
                templateUrl: p._links.template.href
            };
        }),
        statusCheck
    };
};
exports.apiPushConfigurationHalToJson = apiPushConfigurationHalToJson;
const siteFlowConfigurationHalToJson = (configuration) => {
    return {
        endpointUrl: configuration.endpointUrl,
        executionType: configuration.executionType,
        canShipEarly: configuration.canShipEarly,
        destination: configuration.destination,
        currencyCode: configuration.currencyCode,
        carrierServicesMapping: configuration.carrierServicesMapping,
        productMapping: configuration.productMapping,
        accounts: configuration._embedded.accounts.map(a => {
            var _a, _b;
            return {
                accountName: a.accountName,
                credentialsUrl: (_b = (_a = a._links) === null || _a === void 0 ? void 0 : _a.credentials) === null || _b === void 0 ? void 0 : _b.href,
                merchantIds: a.merchantIds
            };
        })
    };
};
exports.siteFlowConfigurationHalToJson = siteFlowConfigurationHalToJson;
